import { ColorConstants } from "../../../../constants";

export type ProjectRoadmapRowLabelData = {
  displayName: string | undefined;
  uuid: string | undefined;
  status: string | undefined;
  additionalDates: boolean;
}[];

export type ChartReferenceNodes = {
  tooltipClone?: HTMLElement;
  timelineClone?: SVGElement;
  bars?: SVGElement;
  highlightBars?: SVGElement;
};

export const ProjectRoadmapColourMap: { [key: string]: string } = {
  Feasibility: ColorConstants.INDIGO_500,
  Design: ColorConstants.CORAL_500,
  Implementation: ColorConstants.AQUA_500,
  "Ongoing monitoring": ColorConstants.GREEN_500,

  "Feasibility milestone": ColorConstants.INDIGO_200,
  "Design milestone": ColorConstants.CORAL_200,
  "Implementation milestone": ColorConstants.AQUA_200,
  "Ongoing Monitoring milestone": ColorConstants.GREEN_200,

  "Registration date": ColorConstants.CORAL_500,
  "Project implementation date": ColorConstants.AQUA_500,
  "Project start date": ColorConstants.AQUA_500,
  "Validation date": ColorConstants.AQUA_500,
  "Restoration validation date": ColorConstants.AQUA_500,
  "Certification date": ColorConstants.AQUA_500,
  "Second assessment date": ColorConstants.GREEN_500,
  "Final assessment date": ColorConstants.GREEN_500,
};

export enum ViewMode {
  Months3,
  Months6,
  Year,
  Years3,
  Years10,
  Years20,
}
